import React, {type FC} from 'react';
import s from './MobileSort.scss';
import classNames from 'classnames';
import {
  IProvidedTranslationProps,
  withTranslations,
} from '@wix/wixstores-client-common-components/dist/es/src/outOfIframes/translations';
import {ArrowDown, Arrows} from '../../../../icons/dist';
import {useGlobals, withGlobals} from '../../../../globalPropsContext';
import {ISortingOption} from '../../../../types/sorting';
import {ConditionalRender} from '../../ConditionalRender/ConditionalRender';

export enum MobileSortDataHooks {
  Root = 'mobile-sort',
  SelectSort = 'select-sort',
  Option = 'option',
  SortIcon = 'sort-icon',
}

const MobileSortComp: FC<IProvidedTranslationProps> = ({t}) => {
  const {selectedSort, sortingOptions, sortProducts, sendSortClickBiEvent, hasFilters} = useGlobals();

  const onChange = (event, sortOptions: ISortingOption[]) => {
    const sortingOption = sortOptions.find((option) => option.id === event.target.value);
    sortProducts(sortingOption);
  };

  const renderIcon = () => {
    if (!hasFilters) {
      return (
        <span className={s.selectButton}>
          <ArrowDown className={s.arrowDown} />
        </span>
      );
    }

    return (
      <span className={classNames(s.selectButton, s.centered)}>
        <ConditionalRender by="galleryShowFilters">
          <Arrows size="32" className={s.arrows} data-hook={MobileSortDataHooks.SortIcon} />
        </ConditionalRender>
        <ConditionalRender by="shouldRenderMobileSortButtonIconWhenFiltersDisabled">
          <ArrowDown className={s.arrowDown} />
        </ConditionalRender>
      </span>
    );
  };

  return (
    <div className={classNames(s.wrapper, {[s.withFilters]: hasFilters})} data-hook={MobileSortDataHooks.Root}>
      {renderIcon()}
      <select
        onClick={() => sendSortClickBiEvent()}
        data-hook={MobileSortDataHooks.SelectSort}
        id={'sortBy'}
        onChange={(event) => onChange(event, sortingOptions)}
        className={classNames(s.mobileSortSelect, s.whenFiltersDisabled, {[s.withoutFilters]: !hasFilters})}
        value={selectedSort.id}>
        {sortingOptions.map((sortOption) => {
          return (
            <option key={sortOption.id} data-hook={MobileSortDataHooks.Option} value={sortOption.id}>
              {t(sortOption.titleKey)}
            </option>
          );
        })}
      </select>
    </div>
  );
};

export const MobileSort = withGlobals(withTranslations()(MobileSortComp));
